module.exports = __webpack_public_path__ + "static/media/learning-1.6db3dc19.png";